<template>
  <div class="filters-list" data-t="filters-list">
    <MarketsFilterItem
      v-for="(current, index) in currentFilters"
      :key="index"
      :list="current ? filters : []"
      :index="index"
      :item="current"
      :active-id="current ? current.id : null"
      :data-t="`filter-item-${index}`"
      @handle-choose="chooseItem"
    />
  </div>
</template>

<script setup lang="ts">
import type { FilterConfig } from 'markets-store/marketsbook/types'
import MarketsFilterItem from './MarketsFilterItem.vue'

interface Props {
  filters: FilterConfig[]
}
const props = withDefaults(defineProps<Props>(), {
  filters: () => [],
})

const emit = defineEmits<{
  updateFilters: [value: (FilterConfig | null)[]]
}>()

const currentFilters = ref<(FilterConfig | null)[]>([])

const FILTERS_IN_ROW_COUNT = 3
function init(filters: FilterConfig[]) {
  currentFilters.value = []
  for (let i = 0; i < FILTERS_IN_ROW_COUNT; i += 1) {
    const item = filters[i]
    if (item) {
      currentFilters.value.push(item)
    } else currentFilters.value.push(null)
  }
  emit('updateFilters', currentFilters.value)
}
function chooseItem({ id, index }: { id: string; index: number }) {
  const item = props.filters.find((f) => f.id === id)
  const alreadyHasIndex = currentFilters.value.findIndex((f) => f?.id === id)

  if (item) {
    const removed = currentFilters.value.splice(index, 1, item)[0]

    if (alreadyHasIndex >= 0) {
      currentFilters.value.splice(alreadyHasIndex, 1, removed)
    }
  }

  emit('updateFilters', currentFilters.value)
}

watch(
  () => props.filters,
  (newFilters) => {
    init(newFilters)
  },
  {
    immediate: true,
  },
)
</script>

<style scoped>
.filters-list {
  z-index: 1;
  display: flex;
  flex-grow: 1;
  gap: var(--spacing-400);
}
</style>
